import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import FinishingTypes from "services/Admin/FinishingTypesService"

const FinishingTypesPage = (props) => {
        return <SystemPage
                Service={FinishingTypes}
                type={"FinishingType"}
                meta={"Finishing Types"}
                placeholder={"finishing"}
                header={"Finishing Types"}
                hasSub={true}
        />

}

export default FinishingTypesPage;
